import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

export function SupplierListing({ t }) {
    const suppliers = t('suppliers.values', { returnObjects: true });

    return FINN?.travel?.enableSeo ? null : (
        <div className="panel u-mb32">
            <h3>{t('suppliers.title')}:</h3>
            <div className="supplier-listing" data-testid="supplierLogos">
                {suppliers &&
                    suppliers.map &&
                    suppliers.map(supplier => {
                        const name = supplier.toLowerCase().replace(' ', '');
                        return (
                            <img
                                data-testid="supplierLogo"
                                width="66px"
                                height="22px"
                                src={`${FINN.travel.cdnBaseUrl}${FINN.travel.contextPath}assets/img/logo/supplier/66x22/${name}.png`}
                                alt={supplier}
                                key={`supplierListing${name}`}
                            />
                        );
                    })}
            </div>
        </div>
    );
}

SupplierListing.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation()(SupplierListing);
